// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeMain_welcomeSection__Q70bK","welcomeContainer":"WelcomeMain_welcomeContainer__tVd9+","welcomeText":"WelcomeMain_welcomeText__w6vXJ"};